
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { ConfigurationService } from '../core/configuration.service';

@Injectable()
export class AgmService {
  private baseApiUrl: string;

  constructor(configurationService: ConfigurationService, private httpClient: HttpClient) {
    this.baseApiUrl = configurationService.BaseApiUrl;
  }


  create(agmattendance: any): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + 'agmvoterslist/saveAgmAttendace', agmattendance).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  
   
}
